import { hbs } from 'ember-cli-htmlbars';
import { BillAddressError, billingAddressChangeAction, Loading, toggleModalAction, userClickNextAction, userClickBackAction, userClickSaveAction } from '@banking/ui/workflows/card-settings/billing-address';
import { workflowComponent } from '@banking/ui/services/card-management/billing-address';
import globalAddressValidator from '@banking/ui/utils/validator/global-address-validator';
import { chosenAddressChangeAction, validateAddressAction } from '@banking/ui/workflows/common/address-validation';
import { addressEntry } from '@banking/ui/utils/address';
const mapStateToProps = state => ({
  active: state.isOpen,
  address: state.updatedBillingAddress,
  addressValidator: globalAddressValidator,
  chosenAddress: state.addressValidation.chosenAddress,
  countryAddressData: state.countryAddressData,
  currentScreen: state.navigation.current,
  error: state.error !== BillAddressError.None,
  expiringCard: state.expiringCard,
  normalizedAddressEntry: addressEntry(state.addressValidation.normalizedAddress),
  userInputAddressEntry: addressEntry(state.updatedBillingAddress),
  isButtonLoading: state.loading === Loading.ModalButton || state.addressValidation.loading,
  isScreenLoading: state.loading === Loading.Modal
});
const mapActionsToProps = () => ({
  onClose: () => toggleModalAction(false),
  onEditClick: userClickNextAction,
  onSaveClick: (address, isValid) => {
    if (isValid) {
      return validateAddressAction(address);
    }
    return null;
  },
  onValueChange: billingAddressChangeAction,
  onConfirmAddressSelectionClick: userClickSaveAction,
  onConfirmAddressClick: userClickSaveAction,
  onEditUnverifiedAddressClick: userClickBackAction,
  onGoBack: userClickBackAction,
  onChosenAddressChange: chosenAddressChangeAction
});
const template = hbs`
  <Banking::Checking::CardSettings::BillingAddress
    @active={{this.active}}
    @address={{this.address}}
    @addressValidator={{this.args.addressValidator}}
    @chosenAddress={{this.chosenAddress}}
    @currentScreen={{this.currentScreen}}
    @error={{this.error}}
    @expiringCard={{this.expiringCard}}
    @isButtonLoading={{this.isButtonLoading}}
    @isScreenLoading={{this.isScreenLoading}}
    @countryAddressData={{this.countryAddressData}}
    @normalizedAddressEntry={{this.normalizedAddressEntry}}
    @onClose={{this.onClose}}
    @onChosenAddressChange={{this.onChosenAddressChange}}
    @onConfirmAddressClick={{this.onConfirmAddressClick}}
    @onEditUnverifiedAddressClick={{this.onEditUnverifiedAddressClick}}
    @onEditClick={{this.onEditClick}}
    @onGoBack={{this.onGoBack}}
    @onSaveClick={{this.onSaveClick}}
    @onValueChange={{this.onValueChange}}
    @userInputAddressEntry={{this.userInputAddressEntry}}
  />
`;
export default workflowComponent(mapStateToProps, mapActionsToProps)(template);